import { createContext, useContext, useState, useMemo, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const LOCALES = { en: "en_US", fr: "fr_FR", pt: "pt_BR" };

const getInitialLang = () => {
  const param = new URLSearchParams(window.location.search).get("lang");
  return ["en", "fr", "pt"].includes(param) ? param : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const t = useMemo(() => translations[lang], [lang]);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t.seo.title;
    const canonical = lang === "en" ? "https://camilavalentoni.com/" : `https://camilavalentoni.com/?lang=${lang}`;
    const setMeta = (selector, attr, value) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", t.seo.description);
    setMeta('meta[property="og:title"]', "content", t.seo.title);
    setMeta('meta[property="og:description"]', "content", t.seo.description);
    setMeta('meta[property="og:locale"]', "content", LOCALES[lang]);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[name="twitter:title"]', "content", t.seo.title);
    setMeta('meta[name="twitter:description"]', "content", t.seo.description);
    setMeta('link[rel="canonical"]', "href", canonical);
  }, [lang, t]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
